import { FALSY_VALYES } from '../const'

/**
 * 转换请求参数格式
 * @param data 请求参数
 */
export function transformRequest (data: any) {
  if (!data) return data
  if (data instanceof FormData) return data
  if (typeof data !== 'object') return data
  if (data instanceof Array) return data
  if (data instanceof URLSearchParams) return data

  // 存在文件，使用formdata
  const existFile = Object.entries(data).find(([, val]) => val && ['File'].includes((val as any).constructor.name))
  if (existFile) {
    const fd = new FormData()
    Object.entries(data).forEach(([key, val]) => {
      fd.append(key, val as any)
    })
    return fd
  }

  // 其他情况一律使用 URLSearchParams
  return new URLSearchParams(data)
}

/**
 * 清除无效值，会修改传入的data
 * @param requestData 请求参数
 * @param values 无效字段
 * @returns 请求参数
 */
export function cleanFalsyValues (requestData: any, values: boolean | any[] = FALSY_VALYES) {
  if (values === false) {
    return requestData
  }

  const vls: any[] = values === true ? FALSY_VALYES : values

  for (const [key, value] of Object.entries(requestData)) {
    if (vls.includes(value)) {
      delete requestData[key]
    }
  }

  return requestData
}
